import React, { useEffect } from 'react';

import Aboutawardscelebrations from './Aboutawardscelebrations'
import AboutAwardsbanner from './AboutAwardsbanner';
import Aboutusawardsection from './Aboutusawardsection';
import SocialResponsibilitesBanner from './SocialResponsibilitesBanner';
import Socialresponsesectioncontetn from './Socialresponsesectioncontetn';
import SocailresponsibilitesAdvviser from './SocailresponsibilitesAdvviser';
import NewsandeventsBanner from './NewsandeventsBanner';
import Newsandeventscards from './Newsandeventscards';
import Newandeventscards from './Newandeventscards';
import Aerospacehovercards from './Aerospacehovercards';
import Newscardsdata from './Newscardsdata';
const NewandEvents = () => {
     useEffect(() => {
            window.scrollTo(0, 0);
          }, []); // Empty dependency array ensures it only runs once when the component mounts
                  // Scroll to the top of the page when the component mounts
         
    return (
        <div style={{ backgroundColor: '#fff' }}>
            <NewsandeventsBanner />
            <Newsandeventscards />
            {/* <Newandeventscards /> */}
            <Newscardsdata />
            {/* <Aerospacehovercards /> */}
     
          
        </div>
    );
};

export default NewandEvents;
